// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-kenya/calculator-kenya-vaf/calculator-kenya-vaf.component.scss
// module id = 700
// module chunks = 0